import { render, staticRenderFns } from "./RoleDetails.vue?vue&type=template&id=09288289&scoped=true"
import script from "./RoleDetails.vue?vue&type=script&lang=js"
export * from "./RoleDetails.vue?vue&type=script&lang=js"
import style0 from "./RoleDetails.vue?vue&type=style&index=0&id=09288289&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09288289",
  null
  
)

export default component.exports